<template>
    <v-container fluid tag="section">
        <material-card color="primary" icon="mdi-watermark">
            <template #title v-if="id">
                <Питання>: <b>{{ faq.name }} #{{ id }}</b> <br>
            </template>
            <template #title v-else>
                Нове Питання FAQ
            </template>

            <ButtonComeBack class="ml-3 mb-3" />
            <!-- {{ faq }} -->
            <v-row>
                <v-col cols="12" lg="6">
                    <v-form class="form-faq-edit" lazy-validation v-model="isValidForm" ref="formfaq">
                        <!-- ID -->
                        <v-col cols="12" v-if="faq.id">
                            <v-text-field label="ID" v-model="faq.id" readonly />
                        </v-col>
                        <!-- Проєкт -->
                        <v-col cols="12">
                            <v-select v-model="faq.project_id" label="Проекти" cache-items item-text="name"
                                item-value="id" :items="projectList" required :rules="[v => !!v > 0 || errorRequired]"
                                prepend-icon="mdi-format-list-bulleted-type">
                            </v-select>
                        </v-col>
                        <!-- Активний -->
                        <v-col cols="12">
                            <v-switch v-model="faq.is_active" label="Включено"></v-switch>
                        </v-col>
                        <!-- Тема -->
                        <v-col cols="12">
                            <v-select v-model="faq.faq_themes_id" label="Тема FAQ" cache-items  :items="faqThemes" required :rules="[v => !!v > 0 || errorRequired]"
                                prepend-icon="mdi-format-list-bulleted-type">
                            </v-select>
                        </v-col>
                        <!-- Головна сторінка -->
                        <v-col cols="12">
                            <v-switch v-model="faq.main_page" label="Стартова сторінка" hide-details></v-switch>
                        </v-col>
                        <!-- ------------------------------ Каталог ------------------------------ -->
                        <v-col cols="12">
                            <v-treeview :open.sync="opened" @input="saveCat()" v-model="selection" class="ml-n3"
                                :items="goodsCatalog" selectable dense return-object
                                selected-color="primary"></v-treeview>
                        </v-col>


                        <!-- ----------------------------- ТАБИ ----------------------------- -->
                        <v-col cols="12">
                            <v-tabs v-model="tab">
                                <v-tab v-for="local in localization" :key="local.lang_key">
                                    {{ local.name }}
                                </v-tab>
                            </v-tabs>
                        </v-col>

                        <!--Содержымое табов-->
                        <v-col cols="12">
                            <v-tabs-items v-model="tab">
                                <v-tab-item v-for="(item, index) in faq.langs" :key="item.lang_key" :eager="true">
                                    <template>
                                        <!--Питання-->
                                        <v-textarea label="Питання" v-model="item.question" required :rules="[v => true]" />
                                        <!--Відповідь-->
                                        <v-textarea label="Відповідь" v-model="item.answer" required :rules="[v => true]" />
                                        <!--Изображение-->
                                        <ImageUpload v-model="item.image"
                                            @image-upload:change="changeImage($event, item.lang_key)"
                                            :imageBaseUrl="imageBaseUrl" />
                                    </template>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-col>

                        <!-- ------------------------------- Кнопки ------------------------------- -->
                        <v-col cols="12" class="text-right">
                            <v-btn color="primary" min-width="150" @click="updateFaq()">
                                Зберегти
                            </v-btn>
                        </v-col>
                        <Preloader v-if="isSending" />
                    </v-form>

                </v-col>
            </v-row>
        </material-card>
    </v-container>
</template>


<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { IMAGE_BASE_URL } from '@/env.config';

export default {
    name: 'PageFaqProfile',
    props: {
        id: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            enabled: false,
            faq: {
                langs: [],
                is_active: true,
                project_id: null,
                faq_themes_id: null,
                main_page: false,
            },
            opened: [{
                id: 0
            }],
            selection: [],
            items: [],
            // Нужно vuetify для валидации формы
            isValidForm: true,
            // Сообщение об ошибке для обязательных полей
            errorRequired: `Це поле обов'язкове`,
            // Указывает на то что выполняется отправка формы
            isSending: false,
            // Изображения для отправки 
            imagesToSend: {},
            faqImage: null,//'/assets/img/faqs/2v9aj5numrmm1g710skx3wmy0wt3m5sp.png',
            // Базовый url картинки
            imageBaseUrl: `${IMAGE_BASE_URL}faqs/`,
            menu: false,
            menu2: false,
            tab: 0,
            projectList: [],
            catalog: [],
            categories: [],
            faqThemes: [],
        }
    },
    computed: {
        ...mapGetters(['snackbar', 'localization', 'isManager', 'isAdmin']),
        firstLevelCatalog() {
            const cat = this.catalog.filter(item => item.level == 1).map(item => ({ ...item, children: [] }));
            // додати корінь з id 0
            return [{ id: 0, name: 'Меню сайту', level: 0, children: cat }];
        },
        goodsCatalog() {
            return [{ id: 0, name: 'Каталог товарів', level: 0, children: this.catalog }];
        },
        projectId() {
            return this.faq.project_id || 0;
        },

    },
    async mounted() {
        await this.init();
    },
    watch: {
        projectId: {
            async handler(newVal, oldVal) {
                await this.getCatalog();
                if (this.id && this.categories?.length) {
                    this.setCat();
                }
            },
            immediate: false
        }

    },
    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getLocalization']),
        async init() {

            await this.getLocalization();
            await this.getProjectList();
            await this.getFaqThemes();

            if (this.id) {
                await this.getFaq();
                await this.getCatalog();
                this.setCat();
            } else {
                await this.getCatalog();
                this.faq.langs = this.localization.map((el) => {
                    return {
                        lang_key: el.lang_key,
                        lang_name: el.name,
                        name: '',
                        preview: '',
                        text: '',
                    };
                });
            }

        },
        collectByIds(tree, ids) {
            const result = [];
            const idsSet = new Set((ids || []).map(id => Number(id)));

            function traverse(nodes) {
                for (const node of nodes || []) {
                    if (idsSet.has(Number(node.id))) {
                        result.push(node);
                    }
                    if (node.children?.length) {
                        traverse(node.children);
                    }
                }
            }

            traverse(tree);
            return result;
        },
        setCat() {
            this.selection = this.collectByIds(this.goodsCatalog, this.categories);
        },
        async getFaqThemes() {
            try {
                let { data } = await HTTP.post('/get-faq-themes-select-list', {});
                this.faqThemes = data.content;
            } catch (error) {
                console.warn(error);
            }
        },
        async runProcessImagesSend(id) {
            let errors = '';
            for (let key in this.imagesToSend) {
                let item = this.imagesToSend[key];
                let queryParams = {
                    lang_key: key,
                    object_image_id: id,
                    image_type: 'faq_image',
                };
                let result = await item.sendImage(queryParams);
                // Если при загрузке изображений были - показать попап
                if (!result.error) {
                    delete this.imagesToSend[key];
                } else {
                    errors += `${result.error}</br>`;
                    this.setSnackbar({ type: 'error', text: errors });
                }
            }
            this.isSending = false;
        },

    // Зберегти вибрані категорії
    saveCat() {
        this.categories = this.selection.map(item => item.id);
    },
    // Получить каталог
    async getCatalog() {
        try {
            const {
                data
            } = await HTTP.post('/get-catalog', {
                project:  this.projectId
            });
            this.catalog = data?.content?.catalog || [];
        } catch (error) {
            console.warn(error);
        }
    },


    async getFaq() {
        let { data } = await HTTP.post('/get-faq', { 'id': this.$route.params.id });
        this.faq = data.content;
        this.faq.langs.map(item => {
            item.image = item.image ? `${this.imageBaseUrl}${item.image}` : '';
            return item;
        });
        this.categories = this.faq.categories || [];
        return data.content;
    },

    // Изменить список картинок 
    changeImage(data, langKey) {
        if (data.action) {
            this.imagesToSend[langKey] = {
                sendImage: data.sendImage
            };
        } else {
            delete this.imagesToSend[langKey];
        }
    },



    async updateFaq() {
        let queryParams = { ...this.faq, categories: this.categories };

        if (this.isSending) return;
        if (!this.$refs.formfaq.validate()) {
            this.setSnackbar({ type: 'error', text: 'Форма заповнена не вірно' });
            return;
        }

        this.isSending = true;

        try {
            const { data } = await HTTP.post(this.faq.id ? '/update-faq' : '/create-faq', queryParams);

            let isImages = Object.keys(this.imagesToSend)?.length;

            this.setSnackbar({
                type: 'success',
                text: `Данні оновлено. ${isImages ? 'Виконується завантаження зображень.' : ''}`
            });

            if (!isImages) {
                this.isSending = false;
            }
            // сделал через $watch потомучто setSnackbar сделан через "mutation" (не может вернуть промис)
            const unwatch = this.$watch('snackbar.model', function (newVal, oldVal) {
                unwatch();
                // Запускаем загрузку изображений
                if (isImages) {
                    this.runProcessImagesSend(this.faq.id || data.content.insertId);
                }
            });
            // перейти на сторінку FAQList
            if (!this.faq.id) {
                this.$router.push({ name: 'FaqList' });
            }
        } catch (error) {
            console.warn(error);
            this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
            this.isSending = false;
        }
    },

    // Запускает процесс отравки изображений, отправкой занимается "ImageUpload"
    async runProcessImagesSend(id) {
        let errors = '';
        for (let key in this.imagesToSend) {
            let item = this.imagesToSend[key];
            let queryParams = {
                lang_key: key,
                object_image_id: id,
                image_type: 'faq_image',
            };

            let result = await item.sendImage(queryParams);
            // Если при загрузке изображений были - показать попап
            if (!result.error) {
                delete this.imagesToSend[key];
            } else {
                errors += `${result.error}</br>`;
                this.setSnackbar({ type: 'error', text: errors });
            }
        }
        this.isSending = false;
    },
    // Получить список проектов
    async getProjectList() {
        try {
            let { data } = await HTTP.post('/get-projects');
            this.projectList = data.content;
        } catch (error) {
            console.warn(error);
        }
    },

},
}
</script>

<style scoped lang="sass">
  .form-faq-edit
    position: relative
  </style>
